import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import ActivateLink from "../utility/ActivateLink";
import FieldWithApply from "../utility/FieldWithApply";
import Money from '../../../lib/Money.js';
import {toString} from 'lodash';

/**
 * Seen only by agents. Works just like the tax exempt thingy.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function AgentShippingWidget({
  currentAgent, shoppingCart = {}, callbacks
}) {
  let cartProps = shoppingCart?.properties || {};
  // LODASH toString()!  Not the STUPID STUPID STUPID javascript default
  // which is BADLY BROKEN in the way it handles undefined/null
  let value = toString(cartProps['agentShipping']);
  let money = value ? new Money(+value) : null;

  const prompt = <span><span className="fa fa-truck"/>{' '} Override Shipping</span>;

  const onChange = ({name, value}) => {
    callbacks.updateCart({[name]: value});
  }

  return <div className="relative text-sm text-white">
    <ActivateLink
      defaultOpen={!!money}
      className="text-white" prompt={prompt}>
      <div className="text-gray-700"><FieldWithApply
        shoppingCart={shoppingCart} callbacks={callbacks}
        defaultValue={money ? money.toDollars() : ""}
        name='agentShippingMoney'
        placeholder="Shipping"
      /></div>
      <div className="text-white">
        Enter a shipping charge (dollars, like 9.95). For free shipping put a zero (0).
        Clear this field to let cart calculate shipping automatically.
      </div>
    </ActivateLink>
  </div>
}
